import BaseClass from "@/entities/BaseClass";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import {h} from "vue";
import DialogRemoveItem from "@/elements/DialogRemoveItem";

export default class LinksClass extends BaseClass {
    urls = {
        count:  '/rest/distributions/numbers/count',
        list:   '/rest/distributions/numbers/list',
        create: '/rest/distributions/numbers/save',
        single: '/rest/distributions/numbers/single',
        update: '/rest/distributions/numbers/save',
        remove: '/rest/distributions/numbers/delete',

        removeAll: '/rest/distributions/numbers/delete-all',
        saveGroup: '/rest/distributions/numbers/save-group',
    }

    list(resolve = null, reject = null, customFilter = {}) {
        super.count(() => {
            super.list(resolve, reject, customFilter)
        }, null, customFilter);
    }

    saveGroup(entity_id, numbers, resolve = null, reject = null, customFilter = {}) {
        this.loading = true;

        this.makeRequest('saveGroup', {numbers: numbers, distribution_id: entity_id}, Object.assign({}, this.filter, customFilter), (response) => {
            if (typeof resolve === 'function') {
                resolve(response);
            }
        }, reject);
    }

    remove(pks, distribution_id, resolve, reject) {
        const { reveal } = createConfirmDialog(h(DialogRemoveItem, {
            header: 'Подтвердите удаление',
            description: 'После удаления данные не могут быть восстановлены. Вы уверены?',
            action: (modalResolve, modalReject) => {
                this.instance.loading = true;
                this.makeRequest('remove', {pks: pks, distribution_id: distribution_id}, Object.assign({}, this.filter), (data) => {
                    this.instance.loading = false;

                    if (typeof modalResolve === 'function') {
                        modalResolve();
                    }
                    if (typeof resolve === 'function') {
                        resolve(data);
                    }
                }, (error) => {
                    this.instance.loading = false;

                    if (typeof modalResolve === 'function') {
                        modalResolve();
                    }
                    if (typeof resolve === 'function') {
                        resolve(error);
                    }
                });
            }
        }));
        reveal();
    }

    removeAll(distribution_id, resolve, reject, customFilter = {}) {
        const { reveal } = createConfirmDialog(h(DialogRemoveItem, {
            header: 'Подтвердите удаление',
            description: 'После удаления данные не могут быть восстановлены. Вы уверены?',
            action: (modalResolve, modalReject) => {
                this.instance.loading = true;
                this.makeRequest('removeAll', {distribution_id: distribution_id}, Object.assign({}, this.filter, customFilter), (data) => {
                    this.instance.loading = false;

                    if (typeof modalResolve === 'function') {
                        modalResolve();
                    }
                    if (typeof resolve === 'function') {
                        resolve(data);
                    }
                }, (error) => {
                    this.instance.loading = false;

                    if (typeof modalResolve === 'function') {
                        modalResolve();
                    }
                    if (typeof resolve === 'function') {
                        resolve(error);
                    }
                });
            }
        }));
        reveal();
    }

    create(distribution_id, number, resolve, reject) {
        super.create({model: {distribution_id: distribution_id, number: number}}, (data) => {
            this.instance.emitter.emit('distribution-numbers-list-changed');
            if (typeof resolve === 'function') {
                resolve(data);
            }
        }, reject);
    }
}
